<template>
  <div>
    <h2
      class="
        tw-leading-3xl
          tw-text-red-500
        tw-text-l
        tw-mb-1
        "
    >
      <slot name="headline" />
    </h2>
    <div class="tw-text-red-500 tw-mb-2" v-if="!isValid && errorMessage">
      <p>Dies ist ein Pflichtfeld.</p>
      <p>{{ errorMessage }}</p>
    </div>
    <fieldset class="selectors">
      <legend>{{ label }}</legend>
      <div
        class="tw-flex tw-mt-2 tw-flex-col lg:tw-flex-row tw-gap-1 lg:tw-gap-4"
      >
        <template v-for="lotProperty in lotProperties">
          <div
            :key="lotProperty.value"
            :data-qa="lotProperty.dataQa"
            class="lg:tw-w-1/2 tw-flex tw-flex-col"
          >
            <input
              type="radio"
              class="tw-sr-only"
              :id="`versandart${lotProperty.value}`"
              name="versandart"
              tabindex="-1"
              :value="lotProperty.value"
              v-model="selectedLotProperty"
              @change="$emit('change', $event.target.value)"
            />
            <label
              :for="`versandart${lotProperty.value}`"
              tabindex="0"
              @keydown.space.enter="handleKeydown($event, lotProperty.value)"
              class="
                selector-container
                focus:tw-text-black
                tw-rounded-md
                tw-cursor-pointer
                tw-transition-colors
                tw-duration-300
                tw-rounded-2xl
                tw-flex
                tw-flex-1
              "
              :class="[
                `tw-bg-grey-150 tw-border-2 tw-border-grey-150 hover:tw-bg-${primaryColor}-150`,
                selectedLotProperty === lotProperty.value
                  ? `tw-bg-${primaryColor}-150 tw-border-${primaryColor}-500`
                  : ``
              ]"
            >
              <div
                class="
                  selector
                  tw-relative
                  tw-flex
                  tw-flex-col
                  tw-justify-center
                  tw-w-full
                "
              >
                <div
                  class=" tw-absolute
                    tw-ml-2
                    tw-left-0
                    tw-top-1/2
                    tw-transform
                    tw-rounded-full
                    tw-box-content
                    check-circle
                    tw--translate-y-1/2"
                  :class="{
                    'is-checked': isSelected(lotProperty.value)
                  }"
                >
                  <span
                    class="tw-flex-grow-0 tw-rounded-full tw-flex-shrink-0 tw-relative tw-text-white tw-icon tw-icon-haken"
                  ></span>
                </div>

                <strong>{{ lotProperty.headline }}</strong>
                <span class="tw--mt-1/4 tw-text-md">
                  {{ lotProperty.subline }}
                </span>
              </div>
              <span
                class="
                  tw-block
                  tw-text-s
                  tw-px-2
                  tw-py-1
                  tw-border-t-2
                  tw-border-dashed
                "
                :class="[
                  lotProperty.value !== LotType.VoucherLot
                    ? `tw-border-${primaryColor}-500`
                    : `tw-border-white`
                ]"
                v-if="
                  videogreetingTip && lotProperty.value === LotType.VoucherLot
                "
                v-html="videogreetingTip"
              ></span>
            </label>
          </div>
        </template>
      </div>
    </fieldset>

    <slot name="modal-link" v-bind="modal" :lot-properties="lotProperties" />

    <slot name="additional" />
  </div>
</template>

<script>
export default {
  name: 'lotPropertySelector',
  data() {
    return {
      selectedLotProperty: this.$props.selectedProperty,
      activeTipHtml: this.$props.defaultTipHtml,
      isValid: true
    };
  },
  watch: {
    selectedProperty(newValue) {
      this.selectedLotProperty = newValue;
      this.isValid = true;
      this.activeTipHtml = this.activeProperty.tipSelectedHtml
        ? this.activeProperty.tipSelectedHtml
        : this.activeProperty.tipHtml;
    }
  },
  computed: {
    activeProperty() {
      return this.$props.lotProperties.find(
        (property) => property.value === this.selectedLotProperty
      );
    }
  },
  props: {
    label: String,
    defaultTipHtml: String,
    lotProperties: Array,
    selectedProperty: String,
    modal: Object,
    errorMessage: String,
    videogreetingTip: String,
    product: String
  },
  methods: {
    async checkValid() {
      if (
        this.selectedLotProperty === '' ||
        this.selectedLotProperty === null
      ) {
        this.isValid = false;
      }

      return this.isValid;
    },
    isSelected(lotPropertyValue) {
      return this.selectedLotProperty === lotPropertyValue;
    },
    handleKeydown(event, lotPropertyValue) {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        this.selectedLotProperty = lotPropertyValue;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../sass/mixins';

.selector {
  padding: px-to-rem(10px) px-to-rem(10px) px-to-rem(10px) px-to-rem(64px);
}

.selector-container {
  line-height: px-to-rem(24px);
}

.check-circle {
  display: block;
  width: px-to-rem(32px);
  height: px-to-rem(32px);
  font-size: px-to-rem(32px);
  @apply tw-bg-grey-150 tw-border-grey-800 tw-border-1;

  span {
    display: none;
  }

  &.is-checked {
    @apply tw-bg-white tw-border-0;
    // padding: 2px;  <--- To be clear

    span {
      display: block;
      @apply tw-border-green-500 tw-bg-green-500;
    }
  }
}
</style>
